import React, { useEffect, useRef, useState } from "react";
import "../../styles/CommonBbps.css";
import { useDispatch, useSelector } from "react-redux";
import Call_Api from "../../Common/Handileapi/Call_api";
import { path } from "../../routes/Paths";
import Cookies from "js-cookie";
import {
  generateTransactionId,
  isCreditCardInput,
  isInputValid,
} from "../../Common/creditCardBinAPI/CommonFunctions";
import { setDetailsToSend } from "../../redux/slice/detailsToSendSlice";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useNavigate } from "react-router-dom";

const BillAvenueBbps = () => {
  const detailsToSend = useSelector((state) => state?.details?.details || {});
  console.log("detailsToSend in bill avenue bbps ====>>", detailsToSend);
  const userDetails = useSelector((state) => state?.user?.user || {});
  const token = Cookies.get("token");
  const navigate = useNavigate();

  const [parametersList, setParametersList] = useState([]);
  const [amountValidations, setAmountValidations] = useState({
    minAmount: 0,
    maxAmount: 0,
  });
  const [formData, setFormData] = useState({});
  const [touchedFields, setTouchedFields] = useState({});
  const [loading, setLoading] = useState(false);
  const [allFieldsValid, setAllFieldsValid] = useState(false);
  const [billFetchMandatory, setBillFetchMandatory] = useState(false);
  const [firstValueOfFormData, setFirstValueOfFormData] = useState("");
  const [secondValueOfFormData, setSecondValueOfFormData] = useState("");
  const [activePayOutGateWay, setActivePayOutGateWay] = useState("");
  const [selectedOptionalParams, setSelectedOptionalParams] = useState({});
  const [selectedOptionalParam, setSelectedOptionalParam] = useState("");
  const [optionalInputs, setOptionalInputs] = useState([]);
  const [channelName, setChannelName] = useState("MOB");
  const [IsError, setIsError] = useState(false);
  const [IsErrorMessage, setIsErrorMessage] = useState("");

  const dispatch = useDispatch();

  const sanitizeKey = (name) => name.replace(/\s+/g, "_");

  const isInitialLoad = useRef(true);

  useEffect(() => {
    if (isInitialLoad.current) {
      isInitialLoad.current = false;

      if (!detailsToSend?.serviceName) {
        navigate("/BBPS", { replace: true });
      }
    }
  }, [detailsToSend?.serviceName]);

  /* ---------------- HANDLE CHANGE ---------------- */
  const handleChange = (name, value) => {
    setIsError(false);
    const key = name;

    // Remove spaces from input
    const cleanedValue = value.replace(/\s+/g, "");

    setFormData((prev) => ({
      ...prev,
      [key]: cleanedValue,
    }));

    setTouchedFields((prev) => ({
      ...prev,
      [key]: true,
    }));

    // Store credit card number centrally
    if (name?.toLowerCase().includes("card")) {
      dispatch(
        setDetailsToSend({
          ...detailsToSend,
          creditCardNumber: cleanedValue,
          bbpdCreditCardNumber: cleanedValue,
        }),
      );
    }
  };

  // useEffect(() => {
  //   fetchPrePaidBillInfo(detailsToSend?.billerId);
  //   dispatch(
  //     setDetailsToSend((prev) => ({
  //       ...prev,
  //       creditCardNumber: "",
  //     })),
  //   );
  // }, []);

  useEffect(() => {
    if (detailsToSend?.parametersList?.length) {
      setParametersList(detailsToSend.parametersList);
    } else if (detailsToSend?.billerId) {
      fetchPrePaidBillInfo(detailsToSend.billerId);
    }
  }, [detailsToSend?.billerId]);

  /* ---------------- FETCH BILLER INFO ---------------- */
  const fetchPrePaidBillInfo = async (id) => {
    try {
      const response = await Call_Api(
        path.BBPS_BILL_INFO,
        "POST",
        {
          billerId: id,
          billType: "billerInfo",
        },
        token,
      );

      console.log(
        "response in biller info in bbps bill avenue bbps ===>>>",
        response,
      );

      const biller = response?.response?.jsonData?.billerInfoResponse?.biller;
      const amountDetails =
        biller?.billerPaymentChannels?.paymentChannelInfo[0];
      const params = biller?.billerInputParams?.paramInfo || [];
      const paramArray = Array.isArray(params) ? params : [params];

      const mandatoryParams = paramArray.filter(
        (p) => p.isOptional === "false",
      );

      const optionalParams = paramArray.filter((p) => p.isOptional === "true");

      if (optionalParams?.length > 0) {
        setOptionalInputs(optionalParams);
      }

      if (mandatoryParams?.length > 0) {
        setParametersList(mandatoryParams);
      }

      const payGateWay = response?.data?.jsonData?.payOutGateWay;
      setActivePayOutGateWay(payGateWay);

      setBillFetchMandatory(
        biller?.billerFetchRequiremet?.toUpperCase() === "MANDATORY",
      );

      setAmountValidations({
        ...amountValidations,
        minAmount: amountDetails?.minAmount,
      });

      const channelNames = biller?.billerPaymentChannels?.paymentChannelInfo;
      const checkAgt = channelNames.find((items, index) =>
        items.paymentChannelName.includes("AGT"),
      );
      setChannelName(
        checkAgt?.paymentChannelName ? checkAgt?.paymentChannelName : "MOB",
      );
    } catch (error) {
      console.error("Biller info error", error);
    }
  };

  /* ---------------- STATUS CHECK ---------------- */
  const getStatus = (item) => {
    const key = item.paramName;
    const value = formData[key] || "";

    const isCC = isCreditCardInput(item, detailsToSend);
    const min = isCC ? 16 : Number(item.minLength);
    const max = isCC ? 16 : Number(item.maxLength);

    return isInputValid(value, min, max, item.regEx);
  };

  /* ---------------- FORM VALIDATION ---------------- */
  useEffect(() => {
    const mandatoryValid = parametersList.every(
      (field) => getStatus(field) === "valid",
    );

    let optionalValid = true;

    if (optionalInputs.length > 0) {
      optionalValid =
        selectedOptionalParam &&
        getStatus(
          optionalInputs.find((p) => p.paramName === selectedOptionalParam),
        ) === "valid";
    }

    setAllFieldsValid(mandatoryValid && optionalValid);
  }, [formData, parametersList, optionalInputs, selectedOptionalParam]);

  /* ---------------- CONTINUE ---------------- */
  const handleContinue = () => {
    console.log("billFetchMandatory ====>>>", billFetchMandatory);
    billFetchMandatory ? handleBillFetch() : handleBillValidation();
  };

  const handleAmountValidation = () => {
    if (
      detailsToSend?.serviceName === "Credit Card" &&
      formData &&
      typeof formData === "object" &&
      Object.keys(formData).length >= 2
    ) {
      const values = Object.values(formData);
      setFirstValueOfFormData(values[0]);
      setSecondValueOfFormData(values[1]);
    }
  };

  useEffect(() => {
    if (detailsToSend?.serviceName === "Credit Card" && formData) {
      handleAmountValidation();
    }
  }, [detailsToSend?.serviceName, formData]);

  useEffect(() => {
    if (
      detailsToSend?.inputParams &&
      Object.keys(detailsToSend.inputParams).length > 0
    ) {
      setFormData(detailsToSend.inputParams);
    }
  }, [detailsToSend?.inputParams]);

  const paymentInfo = [
    {
      infoName: "VPA",
      infoValue: "qwert, 'loanrepayment'y@ybl",
    },
  ];

  /* ---------------- BILL FETCH ---------------- */
  const handleBillFetch = async () => {
    if (!allFieldsValid) return;

    setLoading(true);
    try {
      const res = await Call_Api(
        path.BBPS_BILLFETCH_SECONDCALL,
        "POST",
        {
          billType: "billFetch",
          mobileNumber: userDetails?.mobileNumber,
          billerId: detailsToSend?.billerId,
          inputParams: formData,
          channelName,
          activeService: activePayOutGateWay,
        },
        token,
      );

      console.log("res in bill fetch in bbps bille avenue =====>>", res);

      const data = res?.response?.jsonData;
      const code = data?.billFetchResponse?.responseCode;
      const billAmount = data?.billFetchResponse?.billerResponse?.billAmount;
      const billerResponse = data?.billFetchResponse?.billerResponse;
      const additionalInfoData =
        data?.billFetchResponse?.additionalInfo?.info || [];
      let additionalInfo = [];
      if (Array.isArray(additionalInfoData)) {
        additionalInfo = additionalInfoData;
      } else if (additionalInfoData && typeof additionalInfoData === "object") {
        additionalInfo = [additionalInfoData];
      } else {
        console.error("Invalid data format for additionalInfo");
      }
      const requestId = res?.response?.requestId;
      const errorMesage =
        data?.billFetchResponse?.errorInfo?.error?.errorMessage;
      if (code === "204") {
        setIsErrorMessage(errorMesage);
        return;
      } else if (code === "001") {
        setIsError(true);
        setIsErrorMessage(errorMesage);
        console.log("Invalid Credentials", `${errorMesage}`);
        return;
      } else if (code === "000") {
        const updatedAmountValidations = {
          minAmount: amountValidations.minAmount,
          maxAmount: billerResponse.billAmount,
        };

        setAmountValidations(updatedAmountValidations);
        dispatch(
          setDetailsToSend({
            ...detailsToSend,
            billType: "billPayRequest",
            billerId: detailsToSend?.billerUniqueId,
            inputParams: formData,
            billerResponse,
            additionalInfo,
            requestId,
            paymentInfo: paymentInfo,
            billDate: billerResponse.billDate,
            billDueDate: billerResponse.dueDate,
            customerName: billerResponse.customerName,
            billAmount,
            amountValidations: updatedAmountValidations,
            ntarTransactionId: generateTransactionId(),
            channelName,
            serviceName: detailsToSend?.serviceName,
            activeService: activePayOutGateWay,
            payOutGateWay: activePayOutGateWay,
            paymentSource: "webApp",
          }),
        );
        if (
          detailsToSend?.serviceName === "Electricity" ||
          detailsToSend?.serviceName === "Water"
        ) {
          navigate("/CreditCardPaymentPay");
        } else {
          navigate("/CreditCardPaymentPay");
        }
      } else {
        console.log("Inetrnal Server", "Please try later");
      }
    } catch (error) {
      alert("Bill Fetch Error");
      console.log("error in bill fetch in bill avenue====>>", error);
    } finally {
      setLoading(false);
    }
  };

  /* ---------------- BILL VALIDATION ---------------- */
  const handleBillValidation = async () => {
    if (!allFieldsValid) return;

    setLoading(true);
    try {
      const res = await Call_Api(
        path.BBPS_BILLFETCH_SECONDCALL,
        "POST",
        {
          billType: "billValidation",
          mobileNumber: userDetails?.mobileNumber,
          billerId: detailsToSend?.billerId,
          inputParams: formData,
          channelName,
          activeService: activePayOutGateWay,
        },
        token,
      );

      const data = res?.response?.jsonData;
      const code = data?.billValidationResponse?.responseCode;
      const billerResponseArray = data?.billFetchResponse?.billerResponse || [];
      const billerResponse = [...billerResponseArray];
      const additionalInfoArray =
        data?.billValidationResponse?.additionalInfo?.info || [];
      const additionalInfo = [...additionalInfoArray];
      const requestId = res?.data?.requestId;
      const errorMesage =
        data?.billValidationResponse?.errorInfo?.error?.errorMessage;
      if (data?.billValidationResponse?.responseCode === "204") {
        console.log("Internal Server", "Something went wrong please try later");
        return;
      } else if (data?.billValidationResponse?.responseCode === "001") {
        setIsError(true);
        setIsErrorMessage(errorMesage);
        console.log("Invalid Credentials", `${errorMesage}`);
        return;
      } else if (
        data?.billValidationResponse?.responseCode === "200" &&
        data?.billValidationResponse?.responseReason === "Failure"
      ) {
        const alertMessage = data?.billValidationResponse?.complianceReason;
        setIsError(true);
        setIsErrorMessage(alertMessage);
        return;
      } else if (
        data?.billValidationResponse?.responseCode === "200" ||
        data?.billValidationResponse?.responseCode === "000"
      ) {
        dispatch(
          setDetailsToSend({
            ...detailsToSend,
            requestId,
            paymentInfo: paymentInfo,
            billType: "billQuickPay",
            mobileNumber: userDetails?.mobileNumber,
            billerId: detailsToSend?.billerUniqueId,
            inputParams: formData,
            amountValidations: amountValidations,
            ntarTransactionId: generateTransactionId(),
            channelName,
            billerResponse,
            additionalInfo,
            serviceName: detailsToSend?.serviceName,
            activeService: activePayOutGateWay,
            payOutGateWay: activePayOutGateWay,
            paymentSource: "webApp",
          }),
        );
        handleAmountValidation();
        navigate("/CreditCardPaymentPay");
      }
    } catch (error) {
      alert("Validation Error");
      console.log("error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="BillAvenueBbps-container">
      <div className="card_s_i">
        <div className="back_title_s">
          <div>
            <button
              className="btn"
              onClick={() => navigate(`/bbps/${detailsToSend?.serviceName}`)}
            >
              <KeyboardBackspaceIcon />
            </button>
          </div>
          <div className="title_s">Enter Details To Pay</div>
        </div>
        <div className="titleImage_s_i">
          <img
            src={detailsToSend?.billerLogo}
            alt="no"
            className="bbpsImage_s"
          />
          <p className="Note_s_wA">{detailsToSend?.subService}</p>
        </div>

        <div>
          {optionalInputs.length > 0 && (
            <div className="form-group">
              <label>
                Select Identifier <span className="text-danger">*</span>
              </label>

              <select
                value={selectedOptionalParam}
                onChange={(e) => {
                  const selected = e.target.value;
                  setSelectedOptionalParam(selected);

                  // Only clear fields related to previous optional param
                  setFormData((prev) => {
                    const updated = { ...prev };
                    optionalInputs.forEach((opt) => {
                      if (opt.paramName !== selected)
                        delete updated[opt.paramName];
                    });
                    return updated;
                  });
                }}
              >
                <option value="">-- Select --</option>
                {optionalInputs.map((item) => (
                  <option key={item.paramName} value={item.paramName}>
                    {item.paramName}
                  </option>
                ))}
              </select>
            </div>
          )}
          {parametersList.map((item, index) => {
            const key = item.paramName;
            const status = getStatus(item);
            const isCC = isCreditCardInput(item, detailsToSend);

            return (
              <div key={index} className="form-group">
                <label>
                  {isCC
                    ? "Enter 16 Digits of Credit Card Number"
                    : item.paramName}
                  {status === "Mandatory" && (
                    <span className="text-danger">*</span>
                  )}
                </label>

                <div style={{ position: "relative" }}>
                  <input
                    type="text"
                    value={formData[key] || ""}
                    maxLength={isCC ? 16 : Number(item.maxLength)}
                    onChange={(e) =>
                      handleChange(item.paramName, e.target.value)
                    }
                    className={
                      touchedFields[key]
                        ? status === "valid"
                          ? "is-valid"
                          : "is-invalid"
                        : ""
                    }
                  />

                  {touchedFields[key] && status === "valid" && (
                    <span
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        color: "#28a745",
                        fontSize: "18px",
                      }}
                    >
                      ✔
                    </span>
                  )}
                </div>

                {touchedFields[key] && status !== "valid" && (
                  <small className="error">Invalid</small>
                )}
              </div>
            );
          })}

          {selectedOptionalParam &&
            (() => {
              const item = optionalInputs.find(
                (p) => p.paramName === selectedOptionalParam,
              );
              const status = getStatus(item);

              return (
                <div className="form-group">
                  <label>
                    {item.paramName} <span className="text-danger">*</span>
                  </label>

                  <input
                    type="text"
                    value={formData[item.paramName] || ""}
                    maxLength={Number(item.maxLength)}
                    onChange={(e) =>
                      handleChange(item.paramName, e.target.value)
                    }
                    className={
                      touchedFields[item.paramName] && status !== "valid"
                        ? "is-invalid"
                        : ""
                    }
                  />
                </div>
              );
            })()}

          {IsError && <div className="text-danger my-2">{IsErrorMessage}</div>}
          <p className="Note_s_wA">
            Note: Don't Refresh till the process is completed !
          </p>
          <button
            disabled={!allFieldsValid || loading}
            className={allFieldsValid ? "btn_s_i active" : "btn_s_i disabled"}
            onClick={handleContinue}
          >
            {loading ? "Please wait..." : "Continue"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BillAvenueBbps;
